import type { JSX, ReactNode } from 'react';

/**
 * Cadre des écrans hors AppShell (connexion, accès refusé) : fond `background`,
 * contenu centré, logotype selon le thème au-dessus de la carte.
 */
export function AuthScreen({ children }: { children: ReactNode }): JSX.Element {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-6 bg-background p-4 text-foreground">
      <div className="flex items-center">
        <img src="/app_black.svg" alt="Majuscule" className="h-9 w-auto dark:hidden" />
        <img src="/app_white.svg" alt="Majuscule" className="hidden h-9 w-auto dark:block" />
      </div>
      <div className="w-full max-w-[380px]">{children}</div>
    </main>
  );
}
